<template>
    <main class="flex flex-col items-center justify-between overflow-y-auto px-4 py-8 md:px-12">
        <figure class="flex flex-col gap-10 lg:w-full lg:gap-11 pb-32">
            <form method="POST" :action="activateUrl" id="active-listing-form">
                <v-csrf-token></v-csrf-token>
                <figure class="mx-auto max-w-xl flex flex-col gap-8">
                    <figure class="flex gap-3">
                        <div><v-icon icon="check-circle" size="8"></v-icon></div>
                        <div class="flex flex-col gap-3">
                            <div class="text-heading-3-desktop">
                                Sprejmite pogoje
                            </div>
                            <div class="text-body-regular text-black-40">
                                V kolikor se ne strinjate, ne morete objaviti oglasov na portalu N24.
                            </div>
                        </div>
                    </figure>
                    <figure class="ml-auto mr-auto flex w-full flex-col gap-8">
                        <ul class="flex flex-col gap-4">
                            <li
                                class="col-span-4"
                            >
                                <v-checkbox
                                    class="text-small-text-medium text-black-78"
                                    checkbox-position="right"
                                    label="<span class='text-black-78'>Strinjam se s pogodbo o oglaševanju</span>"
                                    name="marketing_contract_consent"
                                    value="1"
                                    :checked="marketingContractConsent"
                                    @vchanged="marketingContractConsent = !marketingContractConsent"
                                ></v-checkbox>
                                <!-- description="<a href='#' class='underline'>Pogodba o oglaševanju</a>" TO GRE V ZGORNJI CHECKBOX-->
                            </li>
                            <li
                                class="col-span-4"
                            >
                                <v-checkbox
                                    class="text-small-text-medium text-black-78"
                                    checkbox-position="right"
                                    label="<span class='text-black-78'>Odstopam od pravice do odstopa od pogodbe</span>"
                                    name="waive_right_to_withdraw"
                                    :checked="waiveRightToWithdraw"
                                    @vchanged="waiveRightToWithdraw = !waiveRightToWithdraw"
                                    value="1"
                                ></v-checkbox>
                            </li>
                        </ul>
                    </figure>
                </figure>
                <v-separator classes="max-w-2xl mx-auto w-full"/>
                <figure class="mx-auto flex flex-col gap-8 lg:w-full">
                    <figure class="flex gap-3 mx-auto max-w-xl w-full">
                        <div><v-icon icon="house-check" size="8"></v-icon></div>
                        <div class="flex flex-col gap-3">
                            <div class="text-heading-3-desktop">
                                Izberite trajanje oglasa
                            </div>
                            <div class="text-body-regular text-black-40">
                                Izberite koliko časa bi radi, da je vaš oglas aktiven.
                            </div>
                        </div>
                    </figure>
                    <figure class="flex flex-wrap justify-center gap-x-8 gap-y-6 mt-12 max-w-6xl mx-auto w-full" id="plans">
                        <div class="p-4 rounded-xl relative w-full flex flex-col md:w-auto md:min-w-[250px] max-w-[250px] cursor-pointer" @click="selectSubscription('90-free')"
                            :class="{
                                'bg-white shadow--big-blur': selected !== '90-free',
                                'bg-[#ECF2F1] shadow-inner': selected === '90-free'
                            }"
                        >
                            <div class="bg-green-25 rounded-lg relative overflow-hidden">
                                <div class="absolute left-4 top-4 bg-green rounded-md px-3 py-2 text-heading-4-bold z-10 text-white shadow--big-blur leading-none">
                                    Brezplačno
                                </div>
                                <div class="w-full">
                                    <img src="/assets/images/pricing-plans/free-plan-card.svg" alt="">
                                </div>
                            </div>
                            <div class="p-2 mt-2 flex flex-col gap-3 grow">
                                <p class="text-black-78 text-heading-4-bold">Objava oglasa je brezplačna</p>
                                <div class="grow"></div>
                                <div class="flex justify-between items-center">
                                    <p class="text-green text-heading-3-desktop">0,00 €</p>
                                </div>
                            </div>
                        </div>
                        <template v-for="(plan) in plans">
                            <div class="p-4 rounded-xl relative w-full flex flex-col md:w-auto md:min-w-[250px] max-w-[250px] cursor-pointer" @click="selectSubscription(plan.onOfficeProductId)"
                                :class="{
                                    'bg-white shadow--big-blur': selected !== plan.onOfficeProductId,
                                    'bg-[#ECF2F1] shadow-inner': selected === plan.onOfficeProductId
                                }"
                            >
                                <div class="absolute -right-2 top-[-16px] z-20" v-if="plan.popularBadge === true">
                                    <div
                                        class=" bg-green-50 text-small-text-medium text-white flex items-center gap-2 shadow--big-blur rounded-full px-4 py-2">
                                        <v-icon icon="fire" class="h-5 w-5" />
                                        <span>Največkrat izbrano</span>
                                    </div>
                                </div>
                                <div class="bg-green-25 rounded-lg relative overflow-hidden">
                                    <div class="absolute left-4 top-4 bg-green rounded-md px-3 py-2 text-heading-4-bold z-10 text-white shadow--big-blur leading-none">
                                        {{ plan.days }} dni
                                    </div>
                                    <div class="w-full">
                                        <img src="/assets/images/pricing-plans/immoscout-plan-card.svg" alt="">
                                    </div>
                                </div>
                                <div class="p-2 mt-2 flex flex-col gap-3 grow">
                                    <p class="text-black-78 text-heading-4-bold">{{ plan.name }}</p>
                                    <div class="grow"></div>
                                    <div class="flex justify-between items-center">
                                        <p class="text-green text-heading-3-desktop">{{ $globalFunctions.formatPrice(plan.price) }} <span class="text-green-50">€</span></p>
                                        <div class="flex flex-col text-end">
                                            <p class="text-[#BFBFBF] text-small-text-medium">{{ $globalFunctions.formatPrice(plan.price / (plan.days / 30.0)) }} €/mesec</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </figure>
                </figure>
                <input type="hidden" name="subscription_type" v-model="selected">
            </form>
        </figure>
        <v-set-phone :show="showPhoneModal" :phone-codes="phoneCodes" @close="showPhoneModal = false" @confirmed="phoneConfirmed" :send-sms-route="sendSmsRoute" :process-sms-route="processSmsRoute"/>
    </main>
    <footer
        class="fixed bottom-0 z-10 flex max-h-[102px] min-h-[102px] w-full justify-between border-t bg-white px-4 lg:max-h-[90px] lg:min-h-[90px]">
        <div class="flex w-full justify-center items-center">
            <button class="button flex items-center gap-2" :class="{'button--gray cursor-not-allowed': !validated || loading}" :disabled="!validated || loading" @click="activateListing">
                <span v-text="loading ? 'Aktivacija poteka...' : 'Nadaljujte'"></span>
                <v-icon v-if="!loading" icon="arrow-right" class="h-4 w-4"/>
            </button>
        </div>
    </footer>
</template>

<script>
import SetPhoneLightBox from '../Common/SetPhoneLightBox.vue';
import SectionSeparator from '../CreateListingSimple/SectionSeparator.vue';
export default {
    components: {
        "v-set-phone": SetPhoneLightBox,
        "v-separator": SectionSeparator,
    },
    props: {
        activateUrl: {
            type: String,
            required: true,
        },
        userHasPhone: {
            type: Boolean,
            required: true,
        },
        plans: {
            type: Array,
            required: true,
        },
        sendSmsRoute: {
            type: String,
            required: true,
        },
        processSmsRoute: {
            type: String,
            required: true,
        },
        phoneCodes: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selected: '',
            loading: false,
            showPhoneModal: false,
            userHasPhoneNumber: false,
            marketingContractConsent: false,
            waiveRightToWithdraw: false,
        }
    },
    mounted() {
        this.userHasPhoneNumber = this.userHasPhone;
    },
    computed: {
        validated() {
            if (!this.selected) {
                return false;
            }

            if (!this.marketingContractConsent || !this.waiveRightToWithdraw) {
                return false;
            }

            return true;
        }
    },
    methods: {
        phoneConfirmed() {
            this.showPhoneModal = false;
            this.userHasPhoneNumber = true;
            if (this.validated) {
                this.activateListing();
            }
        },
        selectSubscription(subscription) {
            this.selected = subscription;
        },
        activateListing() {
            if (!this.validated) {
                return;
            }

            if (!this.userHasPhoneNumber) {
                this.showPhoneModal = true;
                return;
            }

            document.getElementById('active-listing-form').submit();
        }
    }
};
</script>
